import { render, staticRenderFns } from "./new_with_email.vue?vue&type=template&id=0e61c082&"
import script from "./new_with_email.vue?vue&type=script&lang=js&"
export * from "./new_with_email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports